export const MAC_TRACKPAD_ZOOM_MULTIPLIER = 1.75;

const macPlatform = (platform) => /mac/i.test(String(platform || ""));

export const amplifiedMacTrackpadWheelInit = ({
  event,
  platform,
  multiplier = MAC_TRACKPAD_ZOOM_MULTIPLIER,
} = {}) => {
  const deltaX = Number(event?.deltaX);
  const deltaY = Number(event?.deltaY);
  if (
    !event ||
    !macPlatform(platform) ||
    Number(event.deltaMode) !== 0 ||
    !Number.isFinite(deltaX) ||
    !Number.isFinite(deltaY) ||
    deltaY === 0 ||
    Math.abs(deltaY) <= Math.abs(deltaX) ||
    !Number.isFinite(Number(multiplier)) ||
    Number(multiplier) <= 1
  ) {
    return null;
  }

  return {
    bubbles: true,
    cancelable: true,
    composed: true,
    view: typeof window === "undefined" ? null : window,
    detail: Number(event.detail) || 0,
    screenX: Number(event.screenX) || 0,
    screenY: Number(event.screenY) || 0,
    clientX: Number(event.clientX) || 0,
    clientY: Number(event.clientY) || 0,
    button: Number(event.button) || 0,
    buttons: Number(event.buttons) || 0,
    ctrlKey: Boolean(event.ctrlKey),
    shiftKey: Boolean(event.shiftKey),
    altKey: Boolean(event.altKey),
    metaKey: Boolean(event.metaKey),
    deltaX,
    deltaY: deltaY * Number(multiplier),
    deltaZ: Number(event.deltaZ) || 0,
    deltaMode: Number(event.deltaMode) || 0,
  };
};

export const installMacTrackpadZoomAmplifier = ({
  element,
  platform =
    typeof navigator === "undefined"
      ? ""
      : navigator.userAgentData?.platform || navigator.platform || navigator.userAgent,
  multiplier = MAC_TRACKPAD_ZOOM_MULTIPLIER,
} = {}) => {
  if (!element?.addEventListener || typeof WheelEvent === "undefined") {
    return () => {};
  }

  const redispatchedEvents = new WeakSet();
  const handleWheel = (event) => {
    if (redispatchedEvents.has(event)) return;
    const wheelInit = amplifiedMacTrackpadWheelInit({
      event,
      platform,
      multiplier,
    });
    const target = event.target;
    if (!wheelInit || !target?.dispatchEvent) return;

    const amplifiedEvent = new WheelEvent("wheel", wheelInit);
    redispatchedEvents.add(amplifiedEvent);
    event.preventDefault();
    event.stopPropagation();
    target.dispatchEvent(amplifiedEvent);
  };

  element.addEventListener("wheel", handleWheel, {
    capture: true,
    passive: false,
  });
  return () => {
    element.removeEventListener("wheel", handleWheel, { capture: true });
  };
};
